export const EDIT_ICON = '$edit-outline';
export const DUPLICATE_ICON = '$content-copy-outline';
export const DELETE_ICON = '$delete-outline';
export const ARCHIVE_ICON = 'mdi-archive-outline';
export const OPEN_IN_ICON = '$send-backward';
export const VIEW_ICON = '$file-open-outline';
